import { useEffect, useContext } from 'react';

import { EvidenceAPI } from '../../enums';
import { getCoordinates } from './map-api';

import { EvidenceContext, Filter, ApiFilterOperation } from '@eas/common-web';
import { MapEvidenceContext } from '../evidence/map-evidence/map-context';

import { MarkerPopupConfig } from './hook/marker-popup-factory';

import { createLeafletMarker } from './marker';
import { MapContext } from './map-ctx';
import { MarkerProps, CrzpMarker } from './map-types';

type Props = {
  api: EvidenceAPI | undefined;
  markerPopupConfig?: MarkerPopupConfig<any>;
  createLeafletMarker?: (
    props: MarkerProps
  ) => {
    leafletMarker: L.Marker;
    markerData: CrzpMarker;
  };
};
export function RemoteMarkers(props: Props) {
  const { api, markerPopupConfig } = props;
  const evidence = useContext(EvidenceContext);
  const mapEvidence = useContext(MapEvidenceContext);
  const { map } = useContext(MapContext);

  const params = evidence?.tableSource?.getParams();

  const filters = mapEvidence?.withFilters
    ? params.filters?.map((filter: Filter) =>
        filter.operation === ApiFilterOperation.CONTAINS
          ? { ...filter, asciiFolding: false }
          : filter
      )
    : [];

  useEffect(() => {
    const fetchData = async () => {
      const leftCorner = map.current?.getLeftTopCornerCoordinates();
      const rightCorner = map.current?.getRightBottomCornerCoordinates();

      if (!api || !leftCorner || !rightCorner) {
        return;
      }

      map.current?.clearMarkers();

      map.current?.showLoader();

      const coordinates = await getCoordinates(
        leftCorner,
        rightCorner,
        filters,
        api
      );

      map.current?.hideLoader();

      // chunking markers to avoid browser crash
      let index = 0;

      function addMarkers() {
        const chunk = coordinates
          .slice(index, index + 1000)
          .map(props?.createLeafletMarker ?? createLeafletMarker);

        map.current?.addLeafletMarkers(chunk, {
          markerPopupConfig,
        });
        index += 1000;

        if (index < coordinates.length) {
          requestAnimationFrame(addMarkers);
        }
      }

      requestAnimationFrame(addMarkers);
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, mapEvidence?.withFilters, map.current, props?.createLeafletMarker]);

  return null;
}
